import { useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

export function BadgeMultiSelect({ selected, options, onSave, placeholder, addLabel }: {
  selected: string[] | null; options: string[]; onSave: (v: string[]) => void; placeholder: string; addLabel?: string;
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState<string[]>(selected || []);

  const toggle = (opt: string) => {
    setDraft((prev) => prev.includes(opt) ? prev.filter((v) => v !== opt) : [...prev, opt]);
  };

  if (!editing) {
    return (
      <div
        className="cursor-pointer hover:bg-accent/50 rounded px-1 -mx-1 py-0.5 transition-colors"
        onClick={() => { setDraft(selected || []); setEditing(true); }}
      >
        {selected && selected.length > 0 ? (
          <div className="flex flex-wrap gap-1">
            {selected.map((t) => (
              <Badge key={t} variant="secondary" className="text-xs">{t}</Badge>
            ))}
          </div>
        ) : (
          addLabel
            ? <span className="text-sm font-semibold text-primary-text">{addLabel}</span>
            : <span className="text-sm text-muted-foreground/50 italic">{placeholder}</span>
        )}
      </div>
    );
  }

  return (
    <div className="border rounded p-2 bg-background space-y-1.5">
      <div className="grid grid-cols-2 gap-1">
        {options.map((opt) => (
          <label key={opt} className="flex items-center gap-1.5 text-xs cursor-pointer hover:bg-accent/50 rounded px-1 py-0.5">
            <Checkbox
              checked={draft.includes(opt)}
              onCheckedChange={() => toggle(opt)}
              className="h-3.5 w-3.5"
            />
            {opt}
          </label>
        ))}
      </div>
      <div className="flex justify-end gap-1 pt-1 border-t">
        <Button variant="ghost" size="sm" className="h-6 text-xs" onClick={() => setEditing(false)}>
          Cancel
        </Button>
        <Button size="sm" className="h-6 text-xs" onClick={() => { onSave(draft); setEditing(false); }}>
          Save
        </Button>
      </div>
    </div>
  );
}
